import React, { useCallback, useEffect } from 'react';
import './SubjectRequestDetail.css';
import Layout from '../../../../../components/Layout';
import AdminNavbar from '../../../../../components/Admin/AdminNavbar/AdminNavbar';
import { Box, Divider, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import SubjectApproveModal from '../../../../../components/Admin/Request/SubjectRequest/SubjectApproveModel/SubjectApproveModel';
import SubjectRejectModal from '../../../../../components/Admin/Request/SubjectRequest/SubjectRejectModel/SubjectRejectModel';
import { axiosInstance } from '../../../../../utils/tokenUtils';
import { formatDate, formatDateShort } from '../../../../../utils/dateUtils';
import { useAuth } from '../../../../../context/AuthContext';
import DocumentLogo from '../../../../../assets/Admin/document-logo.svg';

const StatusColor = {
  approval_pending: { color: '#EBBF37', bgcolor: '#FFFAEC', value: 'Pending' },
  approved: { color: '#14B334', bgcolor: '#F2FFF5', value: 'Approved' },
  rejected: { color: '#E14949', bgcolor: '#FFE5E5', value: 'Rejected' },
};

const LevelToTeachColor = {
  college_level: {
    color: '#14B334',
    bgcolor: '#F2FFF5',
    value: 'College Level',
  },
  high_school: {
    color: '#E0AD14',
    bgcolor: '#FFFBF0',
    value: 'High School',
  },
  middle_school: {
    color: '#6B60E7',
    bgcolor: '#F0EFFF',
    value: 'Middle School',
  },
  elementary_level: {
    color: '#14B334',
    bgcolor: '#F2FFF5',
    value: 'Elementary Level',
  },
  beginner: {
    color: '#E0AD14',
    bgcolor: '#FFFBF0',
    value: 'Beginner',
  },
  intermediate: {
    color: '#6B60E7',
    bgcolor: '#F0EFFF',
    value: 'Intermediate',
  },
  professional: {
    color: '#14B334',
    bgcolor: '#F2FFF5',
    value: 'Professional',
  },
};

const SubjectRequestDetails = () => {
  const [auth] = useAuth();
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [teacherDetails, setTeacherDetails] = useState([]);
  // const [commentList, setCommentList] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const { id } = useParams();
  const [rowId, setRowId] = useState(null);
  const [teacherName, setTeacherName] = useState('');
  // const [comment, setComment] = useState("");
  const navigate = useNavigate();
  // const [addComment, setAddComment] = useState(false);
  // State to hold the subject request and related subject details
  const [requestDetails, setRequestDetails] = useState(null);
  const [subjectDetails, setSubjectDetails] = useState(null);

  // Fetch the request, then its teacher, bank, comments, and subject by the request ID
  const getRequestDetails = useCallback(async () => {
    try {
      // get the subject request by request ID
      const { data: request } = await axiosInstance.get(`/admin/subjects/requests/${id}`);
      setRowId(request.id);
      setRequestDetails(request);

      // fetch teacher related to this request
      // Fix: Using the correct teacher ID from the subject request response
      const { data: teacher } = await axiosInstance.get(`/admin/teachers/${request.teacher.id}`);
      setTeacherDetails(teacher);

      // fetch bank details for this teacher
      const { data: bank } = await axiosInstance.get(`/admin/bank_details/${request.teacher.id}`);
      setBankDetails(bank);

      // fetch comments for this teacher
      // const { data: comments } = await axiosInstance.get(
      //   `/admin/teachers/${request.teacher.id}/comments`
      // );
      // setCommentList(comments);

      // Set the subject details directly from the request response
      setSubjectDetails(request.subject);

      // We also need to update the teacher name based on the request.teacher data
      setTeacherName(`${request.teacher.first_name} ${request.teacher.last_name}`);
    } catch (error) {
      console.error('Error fetching request details:', error);
    }
  }, [id]);

  // whenever the ID or comments update, re-fetch everything
  useEffect(() => {
    getRequestDetails();
  }, [getRequestDetails]);

  const handleApprove = () => {
    setOpenApproveModal(true);
  };
  // const handleCommentChange = (e) => {
  //   setComment(e.target.value);
  //   // setAddComment(false);
  // };
  const handleReject = () => {
    setOpenRejectModal(true);
  };

  // const handleSubmit = async () => {
  //   try {
  //     if (comment) {
  //       const res = await axiosInstance.post(`/admin/comments`, {
  //         teacher_id: id,
  //         comment: comment,
  //       });
  //       if (res?.status === 201) {
  //         setComment("");
  //         // setAddComment(true);
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  function formatText(input) {
    return input
      .replace(/_/g, ' ') // Replace underscores with spaces
      .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
  }

  // console.log(teacherDetails)
  console.log(subjectDetails);
  return (
    <Layout title="Klass Online | Requested Subject Detail">
      <Box className="relative h-screen w-full overflow-hidden">
        <Box className="sticky top-0 left-0 right-0 z-[1000] bg-white pr-[10px]">
          <AdminNavbar />
        </Box>
        <Box className="h-[calc(100vh-64px)] overflow-auto relative bg-[#F9F9F9] rounded-lg mr-[10px]">
          <Box className="flex flex-col p-[1rem] gap-3">
            <Box className="flex justify-between items-center">
              <Box className="flex flex-col">
                <Box className="flex items-center gap-2">
                  <Typography
                    className="user-management-request-text"
                    onClick={() => navigate('/admin/subject-request')}
                  >
                    Subject Request {'>'}
                  </Typography>
                  <Typography className="profile-text">Details</Typography>
                </Box>
                <Box className="flex items-center gap-4">
                  <Typography className="teacher-request-name-text">
                    {teacherName ||
                      `${requestDetails?.teacher?.first_name} ${requestDetails?.teacher?.last_name}`}
                  </Typography>
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                      height: '16px',
                      mt: 1,
                      borderColor: '#D5DEE3',
                    }}
                  />
                  <Box
                    sx={{
                      height: '30px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      padding: '4px 8px 4px 8px',
                      borderRadius: '20px',
                      backgroundColor: StatusColor[requestDetails?.status]?.bgcolor,
                      color: StatusColor[requestDetails?.status]?.color,
                      border: `1px solid ${StatusColor[requestDetails?.status]?.color}`,
                      fontFamily: 'Poppins !important',
                      fontSize: '10px !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      lineHeight: 'normal !important',
                    }}
                  >
                    <Typography
                      className="w-[6px] h-[6px] rounded-full"
                      style={{
                        backgroundColor: StatusColor[requestDetails?.status]?.color,
                      }}
                    ></Typography>
                    <Typography className="status-text">
                      {StatusColor[requestDetails?.status]?.value}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {requestDetails?.status === 'approval_pending' && (
                <Box className="flex items-center gap-4">
                  <button className="approve-btn" onClick={handleApprove}>
                    Approve
                  </button>
                  <button className="reject-btn" onClick={handleReject}>
                    Reject
                  </button>
                </Box>
              )}
            </Box>
            <Box className="flex flex-col items-start p-[16px] gap-[16px] bg-[#FFF] rounded-[8px]">
              {(requestDetails?.status === 'rejected' || requestDetails?.status === 'approved') && (
                <Box className="flex flex-col gap-1 w-[100%]">
                  {requestDetails?.status === 'rejected' ? (
                    <Box className="status-container rejected">
                      <Box className="status-info">
                        <Typography className="rejected-status-label">Date</Typography>
                        <Typography className="rejected-status-name">
                          {requestDetails?.rejected_at
                            ? formatDateShort(requestDetails?.rejected_at)
                            : '---'}
                        </Typography>
                      </Box>
                      <Box className="status-info">
                        <Typography className="rejected-status-label">Reason</Typography>
                        <Typography className="rejected-status-name">
                          {formatText(
                            requestDetails.reason ? requestDetails.reason : 'No reason mentioned'
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  ) : (
                    requestDetails?.status === 'approved' && (
                      <Box className="status-container approved">
                        <Box className="status-info">
                          <Typography className="approved-status-label">Approved by</Typography>
                          <Typography className="approved-status-name">
                            {auth?.first_name || 'Admin'}
                          </Typography>
                        </Box>
                        <Box className="status-info">
                          <Typography className="approved-status-label">Date</Typography>
                          <Typography className="approved-status-name">
                            {requestDetails?.approved_at
                              ? formatDateShort(requestDetails?.approved_at)
                              : '---'}
                          </Typography>
                        </Box>
                      </Box>
                    )
                  )}
                </Box>
              )}

              <Box className="flex flex-col gap-1 w-[100%]">
                <Typography className="personal-information-text">Subject Requested</Typography>
                <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#F0F5FF] w-[100%]">
                  <Box className="requested-subject-container ">
                    <Box className="flex flex-col gap-2">
                      <Typography className="personal-information-key-text">Subject</Typography>
                      <Typography className="personal-information-value-text">
                        {requestDetails?.subject?.title || '---'}
                      </Typography>
                      {requestDetails?.subject?.tags && requestDetails.subject.tags.length > 0 && (
                        <Box className="requested-subject-tags-container">
                          {requestDetails.subject.tags.map(tag => (
                            <Box key={tag.id} className="requested-subject-tag">
                              {tag.title}
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>

                    <Box className="flex flex-col gap-2">
                      <Typography className="personal-information-key-text">Date</Typography>
                      <Typography className="personal-information-value-text">
                        {requestDetails?.created_at
                          ? formatDateShort(requestDetails?.created_at)
                          : '---'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box className="flex flex-col gap-1 w-[100%]">
                <Typography className="personal-information-text">Existing Subjects</Typography>
                <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
                  {teacherDetails?.subjects && teacherDetails.subjects.length > 0 ? (
                    <Box className="flex flex-row flex-wrap gap-4 w-full">
                      {teacherDetails.subjects.map(subject => (
                        <Box key={subject.id} className="subject-category-container">
                          <Typography className="subject-category-title">
                            {subject.title}
                          </Typography>
                          {subject.tags && subject.tags.length > 0 && (
                            <Box className="subject-tags-container">
                              {subject.tags.map(tag => (
                                <Box key={tag.id} className="subject-tag">
                                  {tag.title}
                                </Box>
                              ))}
                            </Box>
                          )}
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Typography className="personal-information-value-text">
                      No subjects available
                    </Typography>
                  )}
                </Box>
              </Box>
              <Box className="flex flex-col gap-1 w-[100%]">
                <Typography className="personal-information-text">Personal Information</Typography>
                <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">First Name</Typography>
                    <Typography className="personal-information-value-text">
                      {formatText(teacherDetails?.first_name ? teacherDetails?.first_name : '---')}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Last Name</Typography>
                    <Typography className="personal-information-value-text">
                      {formatText(teacherDetails?.last_name ? teacherDetails?.last_name : '---')}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Email</Typography>
                    <Typography className="personal-information-value-text">
                      {teacherDetails?.email ? teacherDetails?.email : '---'}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Phone Number</Typography>
                    <Typography className="personal-information-value-text">
                      {formatText(teacherDetails?.phone_no ? teacherDetails?.phone_no : '---')}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">
                      Current Location
                    </Typography>
                    <Typography className="personal-information-value-text">
                      {(() => {
                        const city = teacherDetails?.city;
                        const location = teacherDetails?.current_location;
                        if (city && location && city !== location) {
                          return formatText(`${city}, ${location}`);
                        }
                        if (city) {
                          return formatText(city);
                        }
                        if (location) {
                          return formatText(location);
                        }
                        return '---';
                      })()}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Date of Birth</Typography>
                    <Typography className="personal-information-value-text">
                      {teacherDetails?.dob ? formatDate(teacherDetails?.dob, 'DD/MM/YYYY') : '---'}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Gender</Typography>
                    <Typography className="personal-information-value-text">
                      {formatText(teacherDetails?.gender ? teacherDetails?.gender : '---')}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">
                      Registration On
                    </Typography>
                    <Typography className="personal-information-value-text">
                      {teacherDetails?.registration_date
                        ? formatDate(teacherDetails?.registration_date, 'DD/MM/YYYY')
                        : '---'}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Document</Typography>
                    <Box className="flex items-center gap-2">
                      {/* Document Logo */}
                      <img src={DocumentLogo} alt="Document" className="w-[18] h-[18]" />

                      {/* Document Name */}
                      <Typography className="personal-information-value-text">
                        Document.png
                      </Typography>

                      {/* View Button */}
                      {(() => {
                        const fileUrl = teacherDetails.document;
                        const fileExtension = fileUrl?.split('.').pop()?.toLowerCase();
                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(
                          fileExtension
                        );

                        if (isImage) {
                          return (
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              download={false}
                              className="view-button"
                            >
                              View
                            </a>
                          );
                        } else {
                          return (
                            <a
                              href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(fileUrl)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="view-button"
                            >
                              View
                            </a>
                          );
                        }
                      })()}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box className="flex flex-col gap-1 w-[100%]">
                <Typography className="personal-information-text">Bank Information</Typography>
                <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Full Name</Typography>
                    <Typography className="personal-information-value-text">
                      {formatText(bankDetails?.full_name ? bankDetails?.full_name : '---')}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Address</Typography>
                    <Typography className="personal-information-value-text">
                      {formatText(bankDetails?.address ? bankDetails?.address : '---')}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">IBAN Number</Typography>
                    <Typography className="personal-information-value-text">
                      {bankDetails?.IBAN_no ? bankDetails?.IBAN_no : '---'}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">
                      Bank Statement
                    </Typography>
                    <Box className="flex items-center gap-2">
                      {/* Document Logo */}
                      <img src={DocumentLogo} alt="Document" className="w-[18] h-[18]" />

                      {/* Document Name */}
                      <Typography className="personal-information-value-text">
                        Bank Statement.png
                      </Typography>

                      {/* View Button */}
                      {(() => {
                        const fileUrl = bankDetails.statement_url;
                        const fileExtension = fileUrl?.split('.').pop()?.toLowerCase();
                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(
                          fileExtension
                        );

                        if (isImage) {
                          return (
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              download={false}
                              className="view-button"
                            >
                              View
                            </a>
                          );
                        } else {
                          return (
                            <a
                              href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(fileUrl)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="view-button"
                            >
                              View
                            </a>
                          );
                        }
                      })()}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box className="flex flex-col gap-1 w-[100%]">
                <Typography className="personal-information-text">Education Background</Typography>
                <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Degree Name</Typography>
                    <Typography className="personal-information-value-text">
                      {formatText(
                        teacherDetails?.degree_name ? teacherDetails?.degree_name : '---'
                      )}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Institution</Typography>
                    <Typography className="personal-information-value-text">
                      {formatText(teacherDetails?.institute ? teacherDetails?.institute : '---')}
                    </Typography>
                  </Box>

                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">
                      Highest Qualification
                    </Typography>
                    <Typography className="personal-information-value-text">
                      {formatText(
                        teacherDetails?.highest_qualification
                          ? teacherDetails?.highest_qualification
                          : '---'
                      )}
                    </Typography>
                  </Box>

                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">Passing Year</Typography>
                    <Typography className="personal-information-value-text">
                      {teacherDetails?.passing_year ? teacherDetails?.passing_year : '---'}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">CV</Typography>
                    <Box className="flex items-center gap-2">
                      {/* Document Logo */}
                      <img src={DocumentLogo} alt="Document" className="w-[18] h-[18]" />

                      {/* Document Name */}
                      <Typography className="personal-information-value-text">CV.pdf</Typography>

                      {/* View Button */}
                      {(() => {
                        const fileUrl = teacherDetails.cv;
                        const fileExtension = fileUrl?.split('.').pop()?.toLowerCase();
                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(
                          fileExtension
                        );

                        if (isImage) {
                          return (
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              download={false}
                              className="view-button"
                            >
                              View
                            </a>
                          );
                        } else {
                          return (
                            <a
                              href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(fileUrl)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="view-button"
                            >
                              View
                            </a>
                          );
                        }
                      })()}
                    </Box>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">
                      Academic Transcript
                    </Typography>
                    <Box className="flex items-center gap-2">
                      {/* Document Logo */}
                      <img src={DocumentLogo} alt="Document" className="w-[18] h-[18]" />

                      {/* Document Name */}
                      <Typography className="personal-information-value-text">trans.png</Typography>

                      {/* View Button */}
                      {(() => {
                        const fileUrl = teacherDetails.degree;
                        const fileExtension = fileUrl?.split('.').pop()?.toLowerCase();
                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(
                          fileExtension
                        );

                        if (isImage) {
                          return (
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              download={false}
                              className="view-button"
                            >
                              View
                            </a>
                          );
                        } else {
                          return (
                            <a
                              href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(fileUrl)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="view-button"
                            >
                              View
                            </a>
                          );
                        }
                      })()}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box className="flex flex-col gap-1 w-[100%]">
                <Typography className="personal-information-text">
                  Area of Specialisation
                </Typography>
                <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">
                      Levels to Teach
                    </Typography>
                    <Typography className="personal-information-value-text">
                      {requestDetails?.teacher?.level_of_teaching &&
                      requestDetails.teacher.level_of_teaching.length > 0
                        ? requestDetails.teacher.level_of_teaching
                            .map(level => LevelToTeachColor[level]?.value || formatText(level))
                            .join(', ')
                        : '---'}
                    </Typography>
                  </Box>

                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">
                      Years of Experience
                    </Typography>
                    <Typography className="personal-information-value-text">
                      {teacherDetails?.years_of_experience
                        ? teacherDetails?.years_of_experience
                        : '---'}
                    </Typography>
                  </Box>
                  <Box className="flex flex-col gap-2 w-[30%]">
                    <Typography className="personal-information-key-text">
                      Teaching Languages
                    </Typography>

                    <Typography className="personal-information-value-text">
                      {teacherDetails?.teaching_lang && teacherDetails.teaching_lang.length > 0
                        ? teacherDetails.teaching_lang.map(lang => formatText(lang)).join(', ')
                        : '---'}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {openApproveModal && (
        <SubjectApproveModal
          setOpenApproveModal={setOpenApproveModal}
          requestId={rowId}
          subjectName={requestDetails?.subject?.title}
          teacherName={
            teacherName ||
            `${requestDetails?.teacher?.first_name} ${requestDetails?.teacher?.last_name}`
          }
        />
      )}
      {openRejectModal && (
        <SubjectRejectModal
          setOpenRejectModal={setOpenRejectModal}
          rowId={rowId}
          teacherName={
            teacherName ||
            `${requestDetails?.teacher?.first_name} ${requestDetails?.teacher?.last_name}`
          }
        />
      )}
    </Layout>
  );
};

export default SubjectRequestDetails;
